module.exports = __webpack_public_path__ + "img/part4-2.a9041248.png";